export default __webpack_public_path__ + "static/media/arrow.8af9a65b.svg";